import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-pilates': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-pilates&exp=web_auto_checkout~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_auto_checkout/pilates-f'),
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_auto_checkout~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_auto_checkout/chair-tai-chi-m'),
			},
		},
	},
]

export default config
